import { LoginResponse } from '../login'

export interface OauthLoginRequest {
  code: string
  state: string
}

export interface OauthLoginResponse {
  data: LoginResponse
}
